/* eslint-disable no-console */
import React, { useState } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import {
  BrowserRouter as Router, Switch,
} from 'react-router-dom';
import Modal from 'react-modal';
import routes from './config/routes';
import AppRoute, { AppRouteProps } from './components/AppRoute';
import Header from './components/Header';
import Footer from './components/Modules/Footer';
import './styles/globals.scss';
import { LoadingProvider } from './context/LoadingContext';
import NudgeProfileConfirmationModal from './components/Modules/NudgeProfileConfirmationModal';

const App: React.FC = () => {
  const [navigationMenuOpen, setNavigationMenuOpen] = useState(false);
  const isAuthenticated = useIsAuthenticated();
  const [pageBackground, setPageBackground] = useState('bg-white');

  Modal.setAppElement('#root');

  if (process.env.REACT_APP_ENABLE_GTM) {
    const scriptId = 'gtm-script';
    const noscriptId = 'gtm-noscript-iframe';

    const scriptAlreadyExists = document.getElementById(scriptId) != null;
    const noscriptAlreadyExists = document.getElementById(noscriptId) != null;

    if (!scriptAlreadyExists) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-KBV482B');
      `;
      document.head.appendChild(script);
    }

    if (!noscriptAlreadyExists) {
      const noscript = document.createElement('noscript');
      noscript.id = noscriptId;
      noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KBV482B"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
      document.body.appendChild(noscript);
    }
  }

  return (
    <Router getUserConfirmation={() => {
      /* Empty callback to block the default browser prompt */
    }}
    >
      <LoadingProvider>
        <div id="root" className={`flex flex-col min-h-screen ${pageBackground}`}>
          {isAuthenticated
            && (
              <Header
                navigationMenuOpen={navigationMenuOpen}
                setNavigationMenuOpen={setNavigationMenuOpen}
                setPageBackground={setPageBackground}
              />
            )}
          <div className={`${navigationMenuOpen ? 'hidden' : ''} flex-1 flex flex-col`}>
            <Switch>
              {routes.map((route: AppRouteProps) => (
                <AppRoute
                  key={route.path}
                  component={route.component}
                  path={route.path}
                  isPrivate={route.isPrivate}
                  section={route.section}
                />
              ))}
            </Switch>

          </div>
          {isAuthenticated && (
            <>
              <NudgeProfileConfirmationModal />
              <div className="mt-auto pt-12">
                <Footer />
              </div>
            </>
          )}
        </div>
      </LoadingProvider>
    </Router>
  );
};

export default App;
